import request from '../utils/request';

export function getMealList(param) {
    return request({
        url: '/admin/search-meal',
        method: 'GET',
        params: param
    })
}

export function saveMeal(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/meal',
            method: 'POST',
            data
        })
    }

    return request({
        url: '/admin/meal/'+id,
        method: 'PUT',
        data
    })
}

export function deleteMeal(id) {
    return request({
        url: '/admin/meal/'+id,
        method: 'DELETE'
    })
}


export function setMealIsvalidate(id, isvalidate) {
    return request({
        url: '/admin/meal/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}


export function getMealDetail(id) {
    return request({
        url: '/admin/meal/' + id,
        method: 'GET'
    })
}

export function getAllMeal() {
    return request({
        url: '/admin/meal-all',
        method: 'GET'
    })
}

export function addRoomMeal(data) {
    return request({
        url: '/admin/meal/room-meal',
        method: 'POST',
        data
    })
}

export function getRoomMeal(room_id) {
    return request({
        url: '/admin/meal/room-meal/' + room_id,
        method: 'GET'
    })
}

